import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import {
  TablePagination,
  TableFooter,
  Button,
  Stack,
  Typography,
  TableBody,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  tableCellClasses,
  Tooltip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  useMediaQuery,
  Menu,
  Card,
  CardHeader,
  IconButton,
  CardContent,
} from "@mui/material";
import Grid from "@material-ui/core/Grid";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import ConfirmationAlert from "./ConfirmationAlert";
import {
  FEATURE_CUSTOM_PAYMENT,
  FEATURE_CUSTOM_REDUX_V2,
} from "../../../constant";
import { usePrevious } from "../../Utils";
import SearchInput from "./helperComponent/SearchInput";
import {
  hideApiLoader,
  setChatRecordingFiles,
  showApiLoader,
} from "../../../redux/tool-webjam/actions";
import {
  deleteMyRecording,
  getMyRecordingsData,
  searchMyRecordingsData,
} from "../../Request.d";
import { getBaseConfig, isMobileBrowserC } from "../../../Utils";
import { copyText } from "../../../../base/util/copyText.web";
import { FacebookShareButton } from "react-share";
import { filterString, NotificationType, SEARCH_DELAY_TIME } from "./Utils";
import DatePicker from "react-datepicker";
import './room/room.css';
import { messages } from "./messages";
import { setNotificationMessage } from "./payment-reducer/actions";
import { dateFormatter } from "./AbstractHelperComponent";
import { Translate } from "../../../../webjam/language";
import { ct, localeCalender } from "../../../constant-Utils";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "var(--theme-primary-color)",
    color: theme.palette.common.white,
    fontSize: 16,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 16,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function MyRecordings(props) {
  const [page, setPage] = useState(0);

  const [recordPerPage, setRecordPerPage] = useState(10);
  const [isConfirming, setIsConfirming] = useState(false);
  const [recordingId, setRecordingId] = useState("");
  const [pageSearch, setPageSearch] = useState("");
  const [recordings_start_date, setRecordingsStartDate] = useState("");
  const [recordings_end_date, setRecordingsEndDate] = useState("");
  const [selectedRoom, setSelectedRoom] = useState(ct("rta-trmc.dashboard.myRecording.selectRomName"));
  const [selectedRecord, setSelectedRecord] = useState("");
  const [isShrinkFromDate, setIsShrinkFromDate] = useState(false);
  const [isShrinkToDate, setIsShrinkToDate] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentActiveId, setCurrentActiveId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setCurrentActiveId(event.currentTarget.id);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const dispatch = useDispatch();
  const isMobile = isMobileBrowserC();
  const { myRecordingsData, authOrganization, chatFiles } = useSelector(
    (state) => state[FEATURE_CUSTOM_REDUX_V2]
  );

  const { isLeftMenuOpen } = useSelector((state) => state[FEATURE_CUSTOM_PAYMENT])

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    dispatch(showApiLoader());
    dispatch(getMyRecordingsData(`?page=${newPage + 1}`));
  };

  const handleChangeRowsPerPage = (event) => {
    const { target } = event;
    setRecordPerPage(+target.value);
    setPage(0);
  };

  useEffect(() => {
    dispatch(showApiLoader());
    dispatch(getMyRecordingsData("?page=1"));
  }, []);

  const handleSearch = (e, isEmpty = false) => {
    setSelectedRecord(isEmpty ? "" : e?.target?.value);
    setPageSearch(isEmpty ? "" : e?.target?.value);
  };

  let prevSearch = usePrevious(pageSearch);
  useEffect(() => {
    if (prevSearch != undefined) {
      var e = setTimeout(() => {
        hitRecSearchApi("search");
      }, SEARCH_DELAY_TIME);
      return () => clearTimeout(e);
    }
  }, [pageSearch]);

  const downloadRecording = (data) => {
    let recordingUrl =
      getBaseConfig("recordingUrl") +
      "/" +
      authOrganization.name +
      "/recordings/" +
      data?.recording_name +
      ".mp4";
    let recdownload = [
      {
        name: data?.recording_name,
        file: recordingUrl,
        filename: data?.recording_name + ".mp4",
      },
    ];
    if (data.individual_url) {
      let individualUrlData = {
        name: data?.recording_name,
        file: data.individual_url,
        filename: data?.recording_name + ".zip",
      }
      recdownload.push(individualUrlData)
    }
    if (chatFiles) {
      recdownload = chatFiles.concat(recdownload);
    }
    dispatch(setChatRecordingFiles(recdownload));
  };

  const copyUrl = (data) => {
    const recLink =
      getBaseConfig("recordingUrl") +
      "/" +
      authOrganization.name +
      "/recordings/" +
      data?.recording_name +
      ".mp4";
    copyText(recLink);
    dispatch(
      setNotificationMessage({
        isOpen: true,
        type: NotificationType.SUCCESS,
        message: ct("rta-trmc.dashboard.myRecording.recordingLink"),
      })
    );
    setTimeout(() => {
      dispatch(
        setNotificationMessage({
          isOpen: false,
          type: null,
          message: null,
        })
      );
    }, 5000);

  };

  const hitRecSearchApi = (type) => {
    dispatch(showApiLoader());
    let latestPage = myRecordingsData?.data?.paginationData?.page?.currentPage;
    let previousPage = myRecordingsData?.data?.paginationData?.page?.prevPage;
    let nextPage = myRecordingsData?.data?.paginationData?.page?.nextPage;
    let recFromDate = moment(recordings_start_date).format("YYYY-MM-DD");
    let recToDate = moment(recordings_end_date).format("YYYY-MM-DD");
    let pageNumber = 1;

    if (recFromDate == "Invalid date" || recToDate == "Invalid date") {
      recFromDate = "";
      recToDate = "";
    }

    if (type == "delete") {
      pageNumber = latestPage;
    }

    if (type == "prevPage") {
      pageNumber = previousPage;
    }

    if (type == "nextPage") {
      pageNumber = nextPage;
    }

    if (selectedRoom && selectedRoom == ct("rta-trmc.dashboard.myRecording.selectRomName")) {
      dispatch(
        searchMyRecordingsData(
          "?room=" +
          "" +
          "&recording_name=" +
          selectedRecord?.toLowerCase() +
          "&fromDate=" +
          recFromDate +
          "&toDate=" +
          recToDate +
          "&page=" +
          pageNumber
        )
      );
    } else {
      dispatch(
        searchMyRecordingsData(
          "?room=" +
          selectedRoom +
          "&recording_name=" +
          selectedRecord?.toLowerCase() +
          "&fromDate=" +
          recFromDate +
          "&toDate=" +
          recToDate +
          "&page=" +
          pageNumber
        )
      );
    }
  };
  const deleteRecording = (type) => {
    setIsConfirming(false);
    if (type) {
      dispatch(showApiLoader());
      dispatch(deleteMyRecording(recordingId, () => {
        hitRecSearchApi("delete");
      }));
      dispatch(hideApiLoader(13));
    }
  };

  const handleRecDateChange = (date) => {
    if (date.recordings_start_date) {
      setRecordingsStartDate(date.recordings_start_date);
      setRecordingsEndDate("");
    } else if (date.recordings_end_date) {
      if (recordings_start_date == '') {
        dispatch(
          setNotificationMessage({
            isOpen: true,
            type: NotificationType.ERROR,
            message: ct("Translate.messages.startDateValidation"),
          })
        );
        return false;

      } else {
        setRecordingsStartDate(recordings_start_date);
        setRecordingsEndDate(date.recordings_end_date);
      }

    }
  }
  const handleOnFocusDate = (type, action) => {
    if (type === "fromDate" && action === "onFocus") {
      setIsShrinkFromDate(true);
    }

    if (type === "fromDate" && action === "onBlur" && !recordings_start_date) {
      setIsShrinkFromDate(false);
    }
    if (type === "toDate" && action === "onFocus") {
      setIsShrinkToDate(true);
    }

    if (type === "toDate" && action === "onBlur" && !recordings_start_date) {
      setIsShrinkToDate(false);
    }

  }
  const isDesktop = useMediaQuery('(min-width:600px)');
  const tableContainer = { left: 0, right: 0, top: 0 };
  const tableWrapper = { width: '100%', overflow: 'hidden', position: 'relative' };

  return (
    <>
      {isMobile && (
        <Menu
          id={"basic-popup"}
          autoFocus={false}
          anchorEl={anchorEl}
          open={open}
          className="root muiMenuWrapper"
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-popup",
          }}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: "visible",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
            },
          }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          <MenuItem
            id="download-recording"
            sx={{ paddingTop: "0px", paddingBottom: "0px" }}
            onClick={(e) => {
              const activeObj =
                myRecordingsData?.data?.recordingData.find(
                  (r) => r?._id === currentActiveId
                );
              e?.preventDefault();
              downloadRecording(activeObj);
              handleClose();
            }}
          >
            <i className="fa fa-download my-recordings-icons theme-font-color mobile-menu-icon" />
            <Typography>Download</Typography>
          </MenuItem>
          <MenuItem
            id="copy-recording-link"
            sx={{ paddingTop: "0px", paddingBottom: "0px" }}
            onClick={(e) => {
              const activeObj =
                myRecordingsData?.data?.recordingData.find(
                  (r) => r?._id === currentActiveId
                );
              e?.preventDefault();
              copyUrl(activeObj);
              handleClose();
            }}
          >
            <i className="fa fa-clone my-recordings-icons theme-font-color mobile-menu-icon" />
            <Typography>Copy Link</Typography>
          </MenuItem>
          <MenuItem
            id="fb-share-btn"
            sx={{ paddingTop: "0px", paddingBottom: "0px" }}
            onClick={(e) => {
              e?.preventDefault();
              handleClose();
            }}
          >
            <FacebookShareButton
              url={
                getBaseConfig("FbPostUrl") +
                "/" +
                authOrganization.name +
                "/recordings" +
                "?name=" +
                myRecordingsData?.data?.recordingData?.find(
                  (r) => r?._id === currentActiveId
                )?.recording_name +
                ".mp4"
              }
              quote={getBaseConfig("PostUrl")}
              description={getBaseConfig("name") + " " + ct("rta-trmc.conference.videoLinkHere")}
              hashtag={"#" + getBaseConfig("name")}
            >
              <li className="fa fa-facebook-official my-recordings-icons theme-font-color mobile-menu-icon"></li>
            </FacebookShareButton>
            <Typography>Facebook</Typography>
          </MenuItem>
          <MenuItem
            id="mail-share-btn"
            sx={{ paddingTop: "0px", paddingBottom: "0px" }}
            onClick={(e) => {
              // e?.preventDefault();
              handleClose();
            }}
          >
            <i>
              <a
                href={`mailto:max.mustermann@example.com?body=Here is the link to your recording: ${getBaseConfig("recordingUrl") +
                  "/" +
                  authOrganization.name +
                  "/recordings/" +
                  myRecordingsData?.data?.recordingData?.find(
                    (r) => r?._id === currentActiveId
                  )?.recording_name +
                  ".mp4"
                  }`}
              >
                <i className="fa fa-envelope-o my-recordings-icons theme-font-color mobile-menu-icon" />
              </a>
            </i>
            <Typography>Email share</Typography>
          </MenuItem>
          <MenuItem
            id="delete-recording-btn"
            sx={{ paddingTop: "0px", paddingBottom: "0px" }}
            onClick={(e) => {
              e?.preventDefault();
              setRecordingId(currentActiveId);
              setIsConfirming(true);
              handleClose();
            }}
          >
            <i className="fa fa-trash-o payment-theme-icon pointer mobile-menu-icon" style={{ color: "var(--theme-error-color)" }} ></i>
            <Typography>Delete</Typography>
          </MenuItem>
        </Menu>
      )}
      {isConfirming && (
        <ConfirmationAlert
          handleConfirmAction={(type) => deleteRecording(type)}
          title={ct("rta-trmc.dashboard.subscription.deleteConfirm") + " recording?"}
        />
      )}
      <div className={`payment-table-custom-cont ${isLeftMenuOpen ? "sidebar-menu-opened" : ""}`}>
        <div className="filter-wrapper">
          <Grid
            container
            spacing={2}
            className="payment-hosted-room-list-container mb-2 recording-top-wrap"
          >
            <Grid item xs={12} md={3} lg={3} sm={3} className="rec-top-col date-col">
              <FormControl
                variant="filled"
                className={`custom-date-picker-wrapper payment-input ${isShrinkFromDate && !recordings_start_date
                  ? "custom-date-picker-on-focus"
                  : "custom-date-picker"
                  }`}
                sx={{
                  width: "100%",
                  fontSize: 16,
                  textAlign: "left",
                }}
              >
                <InputLabel
                  id="select-standard-date-label"
                  htmlFor="from-date"
                  sx={{ fontSize: 16 }}
                  outlined="true"
                  shrink={isShrinkFromDate}
                  className={
                    isShrinkFromDate && !recordings_start_date
                      ? "custom-date-picker-label"
                      : ""
                  }
                >
                  {ct("rta-trmc.dashboard.myRecording.fromDate")}
                </InputLabel>
                <DatePicker
                  onFocus={() => handleOnFocusDate("fromDate", "onFocus")}
                  onBlur={() => handleOnFocusDate("fromDate", "onBlur")}
                  id="from-date"
                  dateFormat="MM-dd-yyyy"
                  onChange={(date) =>
                    handleRecDateChange({ recordings_start_date: date })
                  }
                  selected={recordings_start_date}
                  value={recordings_start_date}
                  maxDate={new Date()}
                  locale={localeCalender()}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={3} lg={3} sm={3} className="rec-top-col date-col">
              <FormControl
                variant="filled"
                className={`custom-date-picker-wrapper payment-input ${isShrinkToDate && !recordings_end_date
                  ? "custom-date-picker-on-focus"
                  : "custom-date-picker"
                  }`}
                sx={{
                  width: "100%",
                  fontSize: 16,
                  textAlign: "left",
                }}
              >
                <InputLabel
                  id="select-standard-label"
                  sx={{ fontSize: 16 }}
                  outlined="true"
                  shrink={isShrinkToDate}
                  className={
                    isShrinkToDate && !recordings_end_date
                      ? "custom-date-picker-label"
                      : ""
                  }
                >
                  {ct("rta-trmc.dashboard.myRecording.toDate")}
                </InputLabel>
                <DatePicker
                  id="to-date"
                  onFocus={() => handleOnFocusDate("toDate", "onFocus")}
                  onBlur={() => handleOnFocusDate("toDate", "onBlur")}
                  dateFormat="MM-dd-yyyy"
                  onChange={(date) =>
                    handleRecDateChange({ recordings_end_date: date })
                  }
                  selected={recordings_end_date}
                  value={recordings_end_date}
                  placeholderText=""
                  minDate={recordings_start_date}
                  maxDate={new Date()}
                  locale={localeCalender()}
                />
              </FormControl>
            </Grid>
            {/* Select room name is display none, if we want to show in future then remove the display:"none" from Grid */}
            <Grid item xs={12} md={3} lg={2} sm={2} style={{ display: "none" }} className="rec-top-col">
              <FormControl
                variant="filled"
                className="payment-input"
                sx={{
                  width: "100%",
                  fontSize: 16,
                  textAlign: "left",
                }}
              >
                <InputLabel id="select-standard-label" sx={{ fontSize: 16 }}>
                  {ct("rta-trmc.dashboard.myRecording.selectRomName")}
                </InputLabel>
                <Select
                  labelId="select-standard-label"
                  id="select-standard"
                  value={filterString(selectedRoom)}
                  onChange={(e) => setSelectedRoom(e.target.value)}
                  label={ct("rta-trmc.dashboard.myRecording.selectRomName")}
                  name="category"
                  sx={{ fontSize: 16 }}
                >
                  <MenuItem value="" sx={{ fontSize: 16 }}>
                    <em>{ct("rta-trmc.dashboard.myRecording.none")}</em>
                  </MenuItem>
                  {(myRecordingsData?.data?.allRoomNames || []).map(
                    (item, index) => {
                      return (
                        <MenuItem
                          key={index}
                          value={item}
                          sx={{ fontSize: 16 }}
                        >
                          {item}
                        </MenuItem>
                      );
                    }
                  )}
                </Select>
              </FormControl>
            </Grid>
            <Grid
              item
              xs={12}
              md={3}
              lg={2}
              sm={3}
              gap="8"
              paddingLeft={"16px"}
              paddingTop={"8px"}
              className="filter-btn rec-top-col"
            >
              <Button
                id="filter-recording-btn"
                size="large"
                sx={{
                  fontSize: 14,
                  backgroundColor: "var(--theme-primary-color)",
                  height: 50,
                }}
                className="p-theme-btn"
                variant="contained"
                onClick={(e) => {
                  e.preventDefault();
                  hitRecSearchApi("searchAll");
                }}
              >
                {ct("rta-trmc.dashboard.myRecording.filter")}
              </Button>
              {(selectedRecord != "" ||
                recordings_start_date != "" ||
                recordings_end_date != "" ||
                selectedRoom != ct("rta-trmc.dashboard.myRecording.selectRomName")) && (
                  <Button
                    sx={{
                      fontSize: 14,
                      left: 10,
                      height: 50,
                    }}
                    variant="outlined"
                    color="error"
                    onClick={(e) => {
                      e.preventDefault();
                      setIsShrinkFromDate(false);
                      setIsShrinkToDate(false);
                      setSelectedRecord("");
                      setRecordingsStartDate("");
                      setRecordingsEndDate("");
                      setPageSearch("");
                      setSelectedRoom(ct("rta-trmc.dashboard.myRecording.selectRomName"));
                      dispatch(getMyRecordingsData("?page=1"));
                    }}
                  >
                    {ct("rta-trmc.dashboard.myRecording.clear")}
                  </Button>
                )}
            </Grid>

            {/* Search bar */}
            <Grid
              item
              xs={12}
              md={3}
              lg={4}
              sm={3}
              className={`text-left rec-top-col ${!isDesktop ? "mt-4" : ""}`}
            >
              <SearchInput
                pageSearch={pageSearch}
                handleSearch={handleSearch}
                classes={`pull-right ${!isDesktop ? "w-100" : ""}`}
                width={`${!isDesktop ? "100%" : undefined}`}
              />
            </Grid>
          </Grid>
        </div>

        {!isMobile && <div style={tableWrapper}>
          <TableContainer style={!isDesktop ? tableContainer : {}}>
            <Table stickyHeader aria-label="custom pagination table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>{ct("rta-trmc.dashboard.myRecording.recordName")}</StyledTableCell>
                  <StyledTableCell>{ct("rta-trmc.dashboard.myRecording.roomName")}</StyledTableCell>
                  <StyledTableCell>{ct("rta-trmc.dashboard.myRecording.date")}</StyledTableCell>
                  <StyledTableCell>{ct("rta-trmc.dashboard.myRecording.startTime")}</StyledTableCell>
                  <StyledTableCell>{ct("rta-trmc.dashboard.myRecording.fileSize")}</StyledTableCell>
                  <StyledTableCell
                    className={isMobile ? "stickyActionHeader" : ""}
                  >
                    {ct("rta-trmc.dashboard.myRecording.action")}
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>

                {!isMobile && !myRecordingsData?.data?.recordingData?.length && (
                  <TableRow className="w-100">
                    <StyledTableCell
                      colSpan={6}
                      style={{ textAlign: "center" }}
                    >
                      {ct("Translate.typography.noRecordFound")}
                    </StyledTableCell>
                  </TableRow>
                )}
                {(myRecordingsData?.data?.recordingData || []).map(
                  (item, i) => {
                    let recDate = dateFormatter(item.createdAt, "LL");
                    let recTime = dateFormatter(item.createdAt, "LT");
                    const PostUrl = getBaseConfig("PostUrl");
                    let fbShareUrl =
                      getBaseConfig("FbPostUrl") +
                      "/" +
                      authOrganization.name +
                      "/recordings" +
                      "?name=" +
                      item?.recording_name +
                      ".mp4";
                    let recLink =
                      getBaseConfig("recordingUrl") +
                      "/" +
                      authOrganization.name +
                      "/recordings/" +
                      item?.recording_name +
                      ".mp4";
                    return (
                      <TableRow key={i} hover>
                        <StyledTableCell>
                          <Typography
                            sx={{
                              maxWidth: 200,
                              wordBreak: "break-word",
                            }}
                          >
                            {item.recording_name || "-"}
                          </Typography>
                        </StyledTableCell>
                        <StyledTableCell>{item.room || "-"}</StyledTableCell>
                        <StyledTableCell>{recDate || "-"}</StyledTableCell>
                        <StyledTableCell>{recTime || "-"}</StyledTableCell>
                        <StyledTableCell>{item.size || "-"}</StyledTableCell>
                        <StyledTableCell
                          className={isMobile ? "stickyActionColumn" : ""}
                        >
                          {isMobile ? (
                            <i
                              id={item._id}
                              onClick={(e) => handleClick(e)}
                              className="fa fa-ellipsis-h pointer theme-font-color"
                              aria-hidden="true"
                            ></i>
                          ) : (
                            <Stack direction="row" spacing={2}>
                              <Tooltip
                                title={ct("rta-trmc.dialogs.clickHereToDownload")}
                                arrow
                              >
                                <i
                                  id={`download-recording-${i}`}
                                  className="fa fa-download my-recordings-icons theme-font-color"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    downloadRecording(item);
                                  }}
                                />
                              </Tooltip>
                              <Tooltip
                                title={ct("rta-trmc.dialogs.clickHereToCopy")}
                                arrow
                              >
                                <i
                                  id={`copy-recording-link-${i}`}
                                  className="fa fa-clone my-recordings-icons theme-font-color"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    copyUrl(item);
                                  }}
                                />
                              </Tooltip>
                              <Tooltip
                                title={ct("rta-trmc.dialogs.clickHereToShareOnFb")}
                                arrow
                              >
                                <FacebookShareButton
                                  id={`fb-share-btn-${i}`}
                                  url={fbShareUrl}
                                  quote={PostUrl}
                                  description={
                                    getBaseConfig("name") + " " + ct("rta-trmc.conference.videoLinkHere")
                                  }
                                  hashtag={"#" + getBaseConfig("name")}
                                >
                                  <li className="fa fa-facebook-official my-recordings-icons theme-font-color"></li>
                                </FacebookShareButton>
                              </Tooltip>

                              <Tooltip
                                title={ct("rta-trmc.dashboard.myRecording.shareRecording")}
                                arrow
                              >
                                <i>
                                  <a
                                    id={`mail-share-btn-${i}`}
                                    href={`mailto:max.mustermann@example.com?body=Here is the link to your recording: ${recLink}`}
                                  >
                                    <i className="fa fa-envelope-o my-recordings-icons theme-font-color" />
                                  </a>
                                </i>
                              </Tooltip>

                              <Tooltip
                                title={ct("rta-trmc.dashboard.myRecording.deleteRecording")}
                                arrow
                              >
                                <i
                                  id={`delete-recording-btn-${i}`}
                                  className="fa fa-trash-o payment-theme-icon pointer"
                                  style={{ color: "var(--theme-error-color)" }}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setRecordingId(item._id);
                                    setIsConfirming(true);
                                    // deleteRecording(item._id);
                                  }}
                                ></i>
                              </Tooltip>
                            </Stack>
                          )}
                        </StyledTableCell>
                      </TableRow>
                    );
                  }
                )}
              </TableBody>
              <TableFooter>
                {!isMobile && myRecordingsData?.data?.recordingData?.length > 0 ? (
                  <TableRow>
                    <TablePagination
                      rowsPerPageOptions={[10]}
                      count={myRecordingsData?.data?.paginationData?.count || 0}
                      rowsPerPage={recordPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      sx={{
                        fontSize: 16,
                      }}
                      SelectProps={{
                        MenuProps: { classes: { paper: "invite-pagination" } },
                      }}
                      className="welcome-pagination"
                    />
                  </TableRow>
                ) : null}
              </TableFooter>
            </Table>
          </TableContainer>
        </div>}
        {/* Mobile cards start here */}
        {isMobile && !isLoading && !myRecordingsData?.data?.recordingData?.length && (<div className="w-100 text-center" style={{ fontSize: '16px' }}>{ct("Translate.typography.noRecordFound")}</div>)}
        {isMobile && (myRecordingsData?.data?.recordingData || []).map((item, i) => {
          let recDate = dateFormatter(item.createdAt, "LL");
          let recTime = dateFormatter(item.createdAt, "LT");
          return (<Card className="mb-5 custom-card-wrapper" key={i}>
            <CardHeader
              sx={{ paddingBottom: "0px" }}
              action={
                <IconButton data-id={`ellipsis-${i}`} id={item?._id} onClick={handleClick} aria-label="settings">
                  <i
                    className="fa fa-ellipsis-h pointer theme-font-color"
                    aria-hidden="true"
                  ></i>
                </IconButton>
              }
              title={<div className="d-flex"><span><b className="nameTitlewrapper">{ct("rta-trmc.dashboard.myRecording.recordName")} :</b></span><span className="ml-2 NameContentWrapper">{item.recording_name || "N/A"}</span></div>}
            />
            <CardContent style={{ paddingTop: "0px" }}>
              <div className="d-flex"><Typography><b>{ct("rta-trmc.dashboard.myRecording.roomName")} :</b></Typography><Typography className="ml-2">{item.room || "N/A"}</Typography></div>
              <div className="d-flex"><Typography><b>{ct("rta-trmc.dashboard.myRecording.date")} :</b></Typography><Typography className="ml-2">{recDate || "N/A"}</Typography></div>
              <div className="d-flex"><Typography><b>{ct("rta-trmc.dashboard.myRecording.startTime")} :</b></Typography><Typography className="ml-2">{recTime || "N/A"}</Typography></div>
              <div className="d-flex"><Typography><b>{ct("rta-trmc.dashboard.myRecording.fileSize")} :</b></Typography><Typography className="ml-2">{item?.size || "N/A"}</Typography></div>

              {/* <div className="w-100 mt-2"><Button
              variant="contained"
              fullWidth
              size="small"
              startIcon={<i className="fa fa-video-camera"></i>}
              onClick={() => handleRoomAction(row.groupName, 2)}
              sx={{
                fontSize: 14,
                backgroundColor: "var(--theme-primary-color)",
              }}
              className="p-theme-btn"
            >Start Room</Button></div> */}
            </CardContent>
          </Card>)
        })}
        {/* Mobile cards end here */}
        {
          isMobile && myRecordingsData?.data?.recordingData?.length > 0 ? (
            <div className="mobile-pagination-wrapper">
              <TablePagination
                rowsPerPageOptions={[10]}
                count={myRecordingsData?.data?.paginationData?.count || 0}
                rowsPerPage={recordPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                sx={{
                  fontSize: 16,
                }}
                SelectProps={{
                  MenuProps: { classes: { paper: "invite-pagination" } },
                }}
                className="welcome-pagination mobile-pagination"
              />
            </div>
          ) : null
        }
      </div>
    </>
  );
}

export default MyRecordings;
